import { render } from "./Tax.vue?vue&type=template&id=63d9e5a2&scoped=true"
import script from "./Tax.vue?vue&type=script&lang=js"
export * from "./Tax.vue?vue&type=script&lang=js"

import "./Tax.vue?vue&type=style&index=0&id=63d9e5a2&lang=scss&scoped=true"

import exportComponent from "/opt/project/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63d9e5a2"]])

export default __exports__